import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteOrderScheduledOrderFOBActions } from "store/ducks/ordersFob";

export function* deleteOrderScheduledOrderFOBRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/orders-fob-scheduled-delete-order/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(DeleteOrderScheduledOrderFOBActions.success(data));
    notify("success", "Ordem deletada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteOrderScheduledOrderFOBActions.failure(errorMessage));
  }
}
